import React from 'react';

export default function ResultImpressionCard({ tags = [], description = '' }) {
  // Use mock data if none provided to support fallback-safe rendering
  const displayTags = tags.length > 0 ? tags : ['Sharp', 'Calm', 'Confident'];
  const displayDesc = description || 'Your facial structure suggests a composed and intelligent presence.';

  return (
    <div style={{
      background: 'rgba(30, 41, 59, 0.4)',
      backdropFilter: 'blur(12px)',
      border: '1px solid rgba(255, 255, 255, 0.08)',
      borderRadius: '20px',
      padding: '1.75rem',
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
      fontFamily: 'Inter, sans-serif'
    }}>
      <div style={{ fontSize: '0.8rem', color: '#94a3b8', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.1em' }}>
        First Impression
      </div>
      
      <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
        {displayTags.map((tag, idx) => (
          <span key={idx} style={{
            background: 'linear-gradient(135deg, rgba(99,102,241,0.2), rgba(236,72,153,0.1))',
            color: '#f8fafc',
            border: '1px solid rgba(139, 92, 246, 0.3)',
            padding: '6px 14px',
            borderRadius: '12px',
            fontSize: '0.9rem',
            fontWeight: '600'
          }}>
            {tag}
          </span>
        ))}
      </div>
      
      <p style={{ margin: 0, color: '#cbd5e1', lineHeight: '1.6', fontSize: '0.95rem' }}>
        {displayDesc}
      </p>
    </div>
  );
}
